// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3wIL_","bigColWidth":"Table_bigColWidth__34uE7","biggerColWidth":"Table_biggerColWidth__3fO60","row":"Table_row__3pvx0","col":"Table_col__pxAfZ"};